import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// vant 2.6 以上支持反馈组件-分享面板
import { ShareSheet } from "vant";
Vue.use(ShareSheet);
import store from "@/store";
import mainServe from "@/api/main.serve.js";
import loginServe from "@/api/login.serve.js";
import global from "@/utils/global.js";
import { toCorrespondingUrl } from "@/utils/redirectDictionary.js";
import pc from "./routes";
import mobile from "./mobile";

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
var routes = (branches) => {
  var merge = [];
  branches.map(function (item) {
    merge.push.apply(merge, item);
  });
  return merge;
};
var RouteSrc = [];
// if (global.global.ispc) {
//   RouteSrc = [pc];
// } else {
RouteSrc = [mobile];
// }
const router = new VueRouter({
  mode: "history",
  base: "admin",
  routes: routes(RouteSrc),
  scrollBehavior() {
    // 刷新页面滚动条到顶部
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  document.body.scrollTop = 0; // 滚动条回到顶部
  document.documentElement.scrollTop = 0; // 滚动条回到顶部
  if (to.path === "/meetingDetails") {
    let toUrl = global.global.meetingH5Url;
    if (global.global.ispc) {
      toUrl =
        global.global.meetingUrl + `/detail/${to.query.id || to.query.goodsId}`;
    } else {
      toUrl =
        global.global.meetingH5Url +
        `pagesModule/meetingDetails/index?type=8&id=${
          to.query.id || to.query.goodsId
        }`;
    }
    window.location.href = toUrl;
  } else if (global.global.ispc) {
    // 判断用户使用的设备
    let correspondingUrl = toCorrespondingUrl(to.path, to.fullPath, to.query);
    store.dispatch("setIsGetPk", false);
    window.location.href = global.global.SeoUrl + correspondingUrl;
  } else {
    document.title =
      to.meta && to.meta.pageTitle ? to.meta.pageTitle : "中文知识网";
    let pk = sessionStorage.getItem("trip");
    let token = sessionStorage.getItem("token");
    if (!pk || pk === "undefined" || pk === "null") {
      let res = await mainServe.getPk();
      sessionStorage.setItem("trip", res.pk ? res.pk : "");
      token = res.token;
    }

    // 安卓跳转H5时H5主动从安卓上获取用户token（ios端不用主动获取）
    if (from.path === "/" && to.query.hasOwnProperty("out")) {
      if (global.global.isAndroid_ios()) {
        let token = window.android.getUserToken();
        if (token) sessionStorage.setItem("token", token);
      }
      // H5在window上挂载getToken方法
      // APP在H5页面登录时通过调用该方法将token写入到H5上
      window.getToken = (data) => {
        if (global.global.isAndroid_ios()) {
          sessionStorage.setItem("token", data.body.value);
        } else {
          if (typeof data == "string") {
            sessionStorage.setItem("token", JSON.parse(data).body.value);
          }
        }
        window.location.reload();
      };
    } else {
      if (token) {
        if (!sessionStorage.getItem("userInfo")) {
          sessionStorage.setItem("token", token);
          let { content } = await loginServe.getUserInfo();
          sessionStorage.setItem("userInfo", JSON.stringify(content));
        }
      } else {
        store.commit("clearInfo");
      }
    }
    next();
  }
});

export default router;
